import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import AgentParamsForm from './AgentParamsForm';
import { buttonClass, ghostButtonClass } from '../../pages/picture-ai/usePictureAi';

/**
 * Where the agent's parameters are actually written.
 *
 * A prompt and a criteria grid need room; the configuration screen only shows what they amount to.
 * Cancelling restores whatever was there when the panel opened, so trying a rewrite costs nothing.
 */
const AgentParamsModal = ({ open, onClose, onSave, agent, params, onChange, widgetContext, busy }) => {
  const { t } = useTranslation();
  const [snapshot, setSnapshot] = useState(params);

  useEffect(() => { if (open) setSnapshot(params); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [open]);

  const cancel = () => { onChange(snapshot); onClose(); };

  return (
    <Modal
      open={open}
      onClose={cancel}
      title={t('Agent parameters')}
      subtitle={t('What this agent looks for, and how it reports it.')}
      footer={(
        <>
          <button className={ghostButtonClass} disabled={busy} onClick={cancel}>{t('Cancel')}</button>
          <button className={buttonClass} disabled={busy} onClick={async () => { await onSave(); onClose(); }}>
            {t('Save')}
          </button>
        </>
      )}
    >
      <AgentParamsForm
        agent={agent}
        params={params}
        disabled={busy}
        onChange={onChange}
        widgetContext={widgetContext}
      />
    </Modal>
  );
};

export default AgentParamsModal;
